import { request } from "@api/graphql";
import activateLicenseMutation from "@api/mutations/activate-license";

type MutationResult = {
  data: {
    activateLicense: {
      id: string;
    };
  };
};

/**
 * Add a product to cart.
 */
const activateLicense = async (token: string, id: string): Promise<{ id }> => {
  const response = await request({
    query: activateLicenseMutation,
    variables: {
      id,
    },
    token,
  });

  const responseBody = (await response.json()) as MutationResult;
  return responseBody?.data.activateLicense;
};

export default activateLicense;
